export default __webpack_public_path__ + "static/media/f0020-01.91b557fc.png";